import { useContext } from 'react'
import { FieldConfig } from 'formik'
import MenuItem from '@mui/material/MenuItem'
import OutlinedField from '../../common/fields/outlinedField'
import FormikContext from '../../../context/formikContext'
import { getNestedObject } from '../../../utils'
import { Option } from '../../../types'

interface Options {
  listItems: Option[]
}
type Props = FieldConfig & React.ComponentProps<typeof OutlinedField> & Options
export default function SelectFormik({ listItems, name, ...rest }: Props) {
  const formik = useContext(FormikContext)
  const hasError = Boolean(
    getNestedObject(name, formik.touched) && getNestedObject(name, formik.errors),
  )
  
  const shouldShowError = hasError && formik.submitCount > 0
  
  return (
    <OutlinedField
      {...rest}
      {...formik.getFieldProps(name)}
      SelectProps={{
        displayEmpty: true,
      }}
      error={shouldShowError}
      helperText={shouldShowError ? getNestedObject(name, formik.errors) : ''}
      select
      defaultValue=''
    >
      <MenuItem value='' disabled>
        Choisir
      </MenuItem>
      {listItems.map((option) => (
        <MenuItem key={option.id} value={option.id}>
          {option.name}
        </MenuItem>
      ))}
    </OutlinedField>
  )
}